import isThisYear from 'date-fns/isThisYear';
import memoize from 'lodash/memoize';

import { lang as l10nLang } from '@ott/l10n';
import { getBeginOfDateInUTC } from '@ott/utility-date';

import monthShorteningMapByLang from './monthShorteningMapByLang';

const defaultIntlOptions = {
  day: 'numeric',
  timeZone: 'UTC', // https://onetwotripdev.atlassian.net/browse/FC-6
};

const shortenMonth = (formattedDate) => {
  const monthShorteningMap = monthShorteningMapByLang[l10nLang];

  if (monthShorteningMap) {
    for (let longName in monthShorteningMap)
      if (monthShorteningMap.hasOwnProperty(longName)) {
        if (formattedDate.includes(longName)) {
          formattedDate = formattedDate.replace(longName, monthShorteningMap[longName]);
          break;
        }
      }
  }

  return formattedDate;
};

const spacesRegExp = /\s/g;
const dotsRegExp = /\./g;
const nonDigitsStringEndRegExp = /\D+$/;

//wrap in function for ie11
function format(lang, intlOptions) {
  return Intl.DateTimeFormat(lang, intlOptions);
}

const cacheKeyResolver = (lang, intlOptions) => {
  return `${lang}${JSON.stringify(intlOptions)}`;
};

const getFormatter = memoize(format, cacheKeyResolver);

// экспортируется для переиспользования за пределами FormattedDate
export default function formatDate(props) {
  const {
    date,
    showYear = false,
    hideCurrentYear = true,
    showMonth = true,
    isShortMonth = false,
    lang = l10nLang,
    showWeekday = false,
  } = props;

  const shouldShowYear = showYear && (!isThisYear(date) || !hideCurrentYear);

  if (!date) {
    return null;
  }

  const utcDate = getBeginOfDateInUTC(date);

  const intlOptions = {
    ...defaultIntlOptions,
  };

  if (showMonth) {
    const isPolish = l10nLang === 'pl'; // для польского (не правильно short'ится в safari) месяца делаем исключение
    intlOptions.month = isShortMonth && !isPolish ? 'short' : 'long';
  }

  if (shouldShowYear) {
    intlOptions.year = 'numeric';
  }

  if (showWeekday && l10nLang === 'en-us') {
    intlOptions.weekday = 'short';
  }

  const formatter = getFormatter(lang, intlOptions);
  let formattedDate = formatter.format(utcDate);

  if (showWeekday && l10nLang !== 'en-us') {
    const weekDayFormatter = getFormatter(lang, {
      timeZone: defaultIntlOptions.timeZone,
      weekday: 'short',
    });
    formattedDate = `${formattedDate}, ${weekDayFormatter.format(utcDate)}`;
  }

  if (showMonth && isShortMonth) {
    formattedDate = shortenMonth(formattedDate); // сент -> сен, czerwca -> cze
    formattedDate = formattedDate.replace(dotsRegExp, ''); // убираем точки из сокращения месяца
  }

  if (shouldShowYear) {
    formattedDate = formattedDate.replace(nonDigitsStringEndRegExp, ''); // отрезаем "г." в конце
  }

  formattedDate = formattedDate.replace(spacesRegExp, '\u00A0'); // заменяем пробелы на неразрывные

  return formattedDate;
}
